import React, { lazy } from "react";
import { matchPath } from "react-router-dom";

// lazy() that renders synchronously once preloaded (no Suspense flash)
const lazyPage = (load) => {
    let Loaded = null;
    const remember = (mod) => {
        Loaded = mod.default;
        return mod;
    };
    const LazyComp = lazy(() => load().then(remember));
    const Page = (props) =>
        Loaded ? <Loaded {...props} /> : <LazyComp {...props} />;
    Page.preload = () => load().then(remember);
    return Page;
};

const WorkshopFormPage = lazyPage(
    () => import("../pages/Workshops/components/WorkshopForm"),
);

export const publicRoutes = [
    { path: "/", Page: lazyPage(() => import("../pages/Home/Home")) },
    {
        path: "/exhibitions",
        Page: lazyPage(() => import("../pages/Exhibitions/Exhibitions")),
    },
    {
        path: "/accommodation",
        Page: lazyPage(
            () => import("../pages/Accommodation/AccommodationDiwali"),
        ),
    },
    {
        path: "/competitions",
        Page: lazyPage(() => import("../pages/Competitions/Competitions")),
    },
    { path: "/ces", Page: lazyPage(() => import("../pages/CES/CES")) },
    {
        path: "/workshops",
        Page: lazyPage(() => import("../pages/Workshops/WorkshopDiwali")),
    },
    {
        path: "/lectures",
        Page: lazyPage(() => import("../pages/Lectures/Lectures")),
    },
    {
        path: "/profile",
        Page: lazyPage(() => import("../pages/Profile/Profile")),
    },
    {
        path: "/contactus",
        Page: lazyPage(() => import("../pages/ContactUs/ContactUs")),
    },
    {
        path: "/technoholix",
        Page: lazyPage(() => import("../pages/Technoholix/Technoholix")),
    },
    {
        path: "/social-initiative",
        Page: lazyPage(
            () => import("../pages/SocialInitiative/SocialInitiative"),
        ),
    },
    { path: "/summit", Page: lazyPage(() => import("../pages/Summit/Summit")) },
    {
        path: "/aic",
        Page: lazyPage(() => import("../pages/AIConference/AIConference")),
    },
    { path: "/twmun", Page: lazyPage(() => import("../pages/TWMUN/TWMUN")) },
    {
        path: "/aws-student-campaign",
        Page: lazyPage(() => import("../pages/AWSCampaign/AWSCampaign")),
    },
    {
        path: "/robowars",
        Page: lazyPage(() => import("../pages/Robowars/Robowars")),
    },
    {
        path: "/robowars/register",
        Page: lazyPage(
            () => import("../pages/Robowars/components/RobowarsForm"),
        ),
    },
    {
        path: "/iftdummy",
        Page: lazyPage(() => import("../pages/IFT/IFT")),
    },
    {
        path: "/ignite",
        Page: lazyPage(() => import("../pages/Ignite/IgniteAlt")),
    },
    {
        path: "/history",
        Page: lazyPage(() => import("../pages/History/History")),
    },
    {
        path: "/recognition",
        Page: lazyPage(() => import("../pages/Recognition/Recognition")),
    },
    { path: "/legals", Page: lazyPage(() => import("../pages/Legals/Legals")) },
    { path: "/media", Page: lazyPage(() => import("../pages/Media/Media")) },
    {
        path: "/gallery",
        Page: lazyPage(() => import("../pages/Gallery/Gallery")),
    },
    {
        path: "/competitions/:compiId",
        Page: lazyPage(
            () => import("../pages/Competitions/components/CompiInternal"),
        ),
    },
    {
        path: "/workshops/:workshopId",
        Page: lazyPage(
            () => import("../pages/Workshops/components/WorkshopInternal"),
        ),
    },
    {
        path: "/workshop-combos/:workshopId",
        Page: lazyPage(
            () => import("../pages/Workshops/components/WsComboInternal"),
        ),
    },
];

// Require Google sign-in
export const protectedRoutes = [
    {
        path: "/competitions/:compiId/register",
        Page: lazyPage(
            () => import("../pages/Competitions/components/CompiForm"),
        ),
    },
    { path: "/workshops/:workshopId/register", Page: WorkshopFormPage },
    { path: "/workshop-combos/:workshopId/register", Page: WorkshopFormPage },
];

const allRoutes = [...publicRoutes, ...protectedRoutes];

// Download the chunk for a pathname. Never rejects.
export const preloadRoute = (pathname) => {
    const route = allRoutes.find((r) =>
        matchPath({ path: r.path, end: true }, pathname),
    );
    return route ? route.Page.preload().catch(() => {}) : Promise.resolve();
};

// Sections that should count as the same "base page"
const SECTION_ALIASES = { "workshop-combos": "workshops" };

export const getBaseKey = (pathname) => {
    const segment = pathname.split("/").filter(Boolean)[0] || "home";
    return SECTION_ALIASES[segment] || segment;
};
